<ng-container *ngIf="dialog$ | async as dialog">
    <div class="paybee-modal-header flex-column">
      <div class="modal-main-heading">Edit Add-On Donation Settings</div>
      <div class="modal-sub-heading">Give donors the option to add a donation to their existing pending cart</div>
    </div>
    <div class="modal-body custom-material-form angular-custom-material-form updated-dropdown">
      @if(campaignsList && campaignsList.length > 0){
        <app-mdb-switch label="Enable Add-On Donation" [formControl]="addOnDonationCampaignEnabled"></app-mdb-switch>
        <div *ngIf="addOnDonationCampaignEnabled.value">
            <ng-container *ngIf="donations$ | async as campaigns">
                <mdb-form-control class="form-fill">
                    <mdb-select [formControl]="addOnDonationCampaignId"class="mdb-select" [filter]="true">
                        <mdb-option *ngFor="let campaign of campaigns" [value]="campaign.id">{{
                        campaign.name
                        }}</mdb-option>
                    </mdb-select>
                    <label mdbLabel class="form-label form-label--paybee">Select Campaign for Add-On Donation</label>
                    @if(showSelectError){
                      <span class="form-fill-error">Please select capmaign for Add-On Donation</span>
                    }
                    </mdb-form-control>
            </ng-container>
        </div>
      }@else{
        <span class="body-1 d-block mb-3">No active donation campaign. Please create one first</span>
      }

    </div>
    <div class="modal-footer modal-footer--import">
      <div class="row">
        <div class="col-2 offset-4">
          <button type="button" class="btn btn--paybee btn--cancel btn--md text-center w-100" (click)="close(dialog, false)">Cancel</button>
        </div>
        <div class="col-2">
          <button type="button" class="btn btn--paybee btn--success btn--md text-center w-100" (click)="onConfirm(dialog, true)">Confirm</button>
        </div>
      </div>
    </div>  
  </ng-container>
  